/*
 * @Author: bianbinbin
 * @Date: 2024-05-28 13:28:15
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-05-28 15:00:54
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/specialPassengers.js
 */
const specialList = r => require.ensure([], () => r(require('@/views/specialPassengers/specialList.vue'), 'specialList'))
const specialPassengers = r => require.ensure([], () => r(require('@/views/specialPassengers/specialPassengers.vue'), 'specialPassengers'))
const router = [
  {
    path: '/specialPassengers',
    name: 'specialPassengers',
    meta: {
      title: ''
    },
    component: specialPassengers
  },
  {
    path: '/specialList',
    name: 'specialList',
    meta: {
      title: ''
    },
    component: specialList
  },
]

export default router
